import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { BodyText, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsTitle = (props: Props) => {
  const { children, color = theme.colors.WHITE } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const responsiveStyles = match([styles.titleXS, styles.titleSM]);
  const dynamicTextStyles = useStyle(() => ({ color }), [color]);
  const textStyles = [responsiveStyles, dynamicTextStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <BodyText sizeMatch={['30']} style={textStyles}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  titleXS: {
    fontSize: 36,
    lineHeight: 39.6,
    letterSpacing: -0.36,
  },
  titleSM: {
    fontSize: 48,
    lineHeight: 52.8,
    letterSpacing: -0.48,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  color?: string;
}>;
